import { Theme, WithStyles, createStyles, CircularProgress, Typography, withStyles } from '@material-ui/core';
import React, { FC } from 'react';
interface LoadingIndicatorProps extends WithStyles<typeof styles> {
    children: string;
}
// declare const _default: ComponentType<Pick<PropsWithChildren<LoadingIndicatorProps>, 'children'> & StyledComponentProps<'message' | 'root' | 'container'>>;

const styles = function(e: Theme) {
  return createStyles({
    container: {
      alignSelf: 'center',
      textAlign: 'center',
      margin: e.spacing(4),
      padding: e.spacing(2),
      backgroundColor: '#eeeeee',
      borderRadius: e.shape.borderRadius
    },
    message: {}
  })
};

// todo fix this export + typings
const LoadingIndicator: FC<LoadingIndicatorProps> = function(props) {
  return (
    <div className = { props.classes.container }>
      <CircularProgress></CircularProgress>
      <Typography
        variant = { 'subtitle2' }
        className = { props.classes.message }>
        { props.children }
      </Typography>
    </div>
  )
};

export default withStyles(styles)(LoadingIndicator);
